import {
  Accordion,
  Box,
  Button,
  Forms,
  Modal,
  TalentechFormFieldTypes,
} from "@talentech/components";
import { useEffect, useMemo, useState } from "react";
import { useEditor } from "@grapesjs/react";
import { DataRecordProps, Editor } from "grapesjs";
import { CustomCommands } from "@/shared/utils";
import React from "react";
import { IFormSection } from "@talentech/components/build/@types/talentech-forms";
import * as yup from "yup";

const dataSourceKey = "external-resources";

const ExternalResourcesModal: React.FC = () => {
  const editor = useEditor();
  const [showModal, setShowModal] = useState(false);

  const additionalResourcesRecords = editor.DataSources?.get(dataSourceKey);

  useEffect(() => {
    editor.Commands.add(CustomCommands.MODAL_EXTERNAL_RESOURCES_OPEN, () =>
      setShowModal(true)
    );
    editor.Commands.add(CustomCommands.MODAL_EXTERNAL_RESOURCES_CLOSE, () =>
      setShowModal(false)
    );

    editor.Commands.add(
      CustomCommands.MODAL_EXTERNAL_RESOURCES_SAVE,
      async (editor: Editor, _ed: any, { form }: { form: DataRecordProps }) => {
        const ds = await editor.DataSources.get(dataSourceKey);
        if (ds) {
          await ds.removeRecord(form.id);
          await ds.addRecord(form);
        } else {
          await editor.DataSources.add({
            id: dataSourceKey,
            records: [form],
          });
        }
      }
    );
  }, []);

  const modalProps = {
    title: "External Resources",
    showModal,

    onClose: () =>
      editor.runCommand(CustomCommands.MODAL_EXTERNAL_RESOURCES_CLOSE),
    buttons: [
      <Button
        onClick={() => window.location.reload()}
        label="Close"
        outline
        key={"close"}
      />,
    ],
  };

  const accordionItems: Array<IFormSection & { title: string }> =
    useMemo(() => {
      const items = ["JavaScript", "CSS"].map((title) => {
        const record = additionalResourcesRecords?.getRecord(
          title.toLowerCase()
        );
        const values = record?.values()[2];
        return {
          id: title.toLowerCase(),
          section: "",
          title,
          repeater: true,
          values,
          fields: [
            {
              type: TalentechFormFieldTypes.TEXT,
              label: "External Resources",
              field: "url",
            },
          ],
        };
      });
      return items;
    }, [additionalResourcesRecords]);

  const submitHandler = (
    values: Record<"javascript" | "css", Array<{ url: string }>>
  ) => {
    const [id, value] = Object.entries(values).flat();
    const payload = {
      id,
      value,
    } as DataRecordProps;
    editor.runCommand(CustomCommands.MODAL_EXTERNAL_RESOURCES_SAVE, {
      form: payload,
    });
  };

  const validationSchema = yup.object().shape({
    javascript: yup.array().of(
      yup.object().shape({
        url: yup
          .string()
          .url("Please provide proper URL")
          .required("This field is required"),
      })
    ),
    css: yup.array().of(
      yup.object().shape({
        url: yup
          .string()
          .url("Please provide proper URL")
          .required("This field is required"),
      })
    ),
  });

  return (
    <Modal {...modalProps}>
      {showModal && (
        <Accordion
          collapseMultiple
          accordionItems={accordionItems.map(({ title, ...item }) => ({
            id: item.id,
            title: title,
            content: (
              <Box role="form" aria-label={item.section} key={item.id}>
                <Forms.Form
                  validationSchema={validationSchema}
                  editable={true}
                  formFields={item}
                  handleReset={() => {}}
                  handleSubmit={submitHandler}
                />
              </Box>
            ),
          }))}
        />
      )}
    </Modal>
  );
};

export default ExternalResourcesModal;
